import { connect } from 'react-redux';
import { toggleModal } from '../EnquireModal/actions';
import EventListener from './EventListener';

export default connect(
  () => ({}),
  { toggleEnquireModal: toggleModal },
)(EventListener);



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/components/EventListener/index.js